var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEgypt = function SvgEgypt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 36 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "Egypt_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#Egypt_svg__a)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v24h36V0H0Z",
    fill: "#F7FCFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "Egypt_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v24h36V0H0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Egypt_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0v8h36V0H0Z",
    fill: "#BF2714"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16v8h36v-8H0Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.793 10.22 1.124.046-.282 5.47-1.124-.046.282-5.47ZM14.967 10.56l1.123.056-.282 4.435-1.123-.056.282-4.435Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.142 10.892 1.121.082-.282 3.056-1.121-.082.282-3.056ZM22.207 10.22l-1.124.046.282 5.47 1.124-.046-.282-5.47ZM21.033 10.56l-1.123.056.282 4.435 1.123-.056-.282-4.435Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.858 10.892-1.121.082.282 3.056 1.121-.082-.282-3.056ZM17.97 15.327l-1.097-.224.464-1.8 1.097.223-.464 1.8Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.81 15.327 1.096-.224-.464-1.8-1.097.223.464 1.8Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.531 15.31h-1.125v-1.768h1.125v1.768ZM16.464 10.913l1.125.025-.066 2.38-1.125-.024.066-2.38ZM18.42 10.913l1.125.025-.065 2.38-1.125-.024.066-2.38Z",
    fill: "#C09302"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.005 15.923.292-.966c1.194.285 2.11.426 2.735.426s1.542-.14 2.736-.426l.292.966c-1.28.306-2.285.46-3.027.46-.743 0-1.747-.154-3.028-.46ZM13.817 10.223c-.075-.661.36-1.108 1.098-1.051.242.019.514.082.877.192l.209.064c.498.158.634.199.662.204-.11-.022.215-.545.29-.633.008.056-.03.048-.12.032l-1.014-.18.722-.66c.253-.23.589-.344.973-.344.04 0 .076-.002.198-.008l.192-.009c.702-.02 1.205.156 1.205.798 0 .23.033.599.087.879.018.094.053.182-.05.22.004-.033.25-.119.632-.26l.046-.018c1.11-.412 1.24-.45 1.599-.257.238.129.466.36.72.707l-.941.547c-.164-.223-.295-.358-.357-.396.141.088-.335.228-.588.322l-.045.017c-.865.321-.979.36-1.226.36-.673 0-.915-.613-.98-1.49-.208.607-.828 1.373-1.338 1.373-.224 0-.116.032-1.044-.261l-.194-.06a3.339 3.339 0 0 0-.611-.143.472.472 0 0 1 .045-.04l-1.047.095Z",
    fill: "#C09302"
  })))));
};
export default SvgEgypt;